<script setup lang="ts">

import { ref, watch } from 'vue';
import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { useForm, Form } from "@library/Components/Forms/Form/v2";
import { LeadOptions, LeadType, FamilyOption } from '../../Types/LeadOptions';

import SelectOption from "../../Components/SelectOption.vue";
import { Map } from '../../Types/Map';

const lead = useLead();
const form = await useForm( lead );
const presentation = usePresentation();
const familyInterest = ref<FamilyOption|null>();
const initialLeadType = lead.leadType;

presentation.backgroundImage = '/images/sample/gkr-watermark.png';

watch( familyInterest, v => 
{
    lead.leadType = ( v == FamilyOption.yes ) ? lead.leadType = LeadType.family : lead.lastName = initialLeadType;
    presentation.goto( Map.ChooseDojo );
});

</script>

<template>

    <Page>
    
        <ImageAndText 
            :src="`/FamilyInterest/family.jpg`" 
            floor-shadow 
            border
            flip>

            <Form 
                :form="form"
                v-slot="{ model, state }"
                class="flex flex-col gap-8">

                <h1 class="mt-6">
                    Have you ever thought about training together? We run family-friendly classes — 
                    it’s a great way to bond with your children and siblings!
                </h1>

                <SelectOption 
                    v-model="familyInterest" 
                    :options="LeadOptions.familyOption"               
                />

            </Form>

        </ImageAndText>

    </Page>

</template>